module.exports = __webpack_public_path__ + "static/media/example-recipient-list.79fe0aef.csv";